import Cookies from 'js-cookie';
/**
 * TODO: Replace other implementations of cookie handling with the one from this shared package.
 */
export function deleteCookie(name, options) {
    Cookies.remove(name, options);
}
export var getCookie = function (name) {
    return Cookies.get(name);
};
export var setCookie = function (name, value, options) {
    Cookies.set(name, "".concat(value), options);
};
export function getCSRFCookie(name, cookies) {
    if (cookies === void 0) { cookies = document.cookie; }
    var pairs = cookies.split(';');
    var found = pairs
        .map(function (pair) { return pair.replace(/^[ ]+/, '').replace(/[ ]$/, ''); })
        .map(function (pair) { return pair.split(/=(?=[a-zA-Z0-9])/); })
        .find(function (pair) { return pair[0] === name; });
    return found ? decodeURIComponent(found[1]) : undefined;
}
